var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e-page adminAuth"},[_c('div',{staticClass:"adminAuth__container"},[_c('h1',[_vm._v("Admin")]),_c('login-form',{on:{"submit":_vm.login}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }